import "jquery-validation";
import "jquery-validation-unobtrusive";
$.validator.setDefaults({
  errorElement: "span",
  highlight: (element, _errorClass, _validClass) => {
    $(element).addClass("is-invalid");
  },
  unhighlight: (element, _errorClass, _validClass) => {
    $(element).removeClass("is-invalid");
  },
});

$.validator.unobtrusive.options = {
  errorPlacement: (error, _element) => {
    error.addClass("invalid-feedback");
  },
};
